import { useEffect, useState, useRef } from "react"
import { SettingsGroup } from "../../../Modules/General"

import FontModule from "../../../Modules/FontModule"
import VariableModule from "../../../Modules/VariableModule"
import FilesModule from "../../../Modules/FilesModule"

import * as Basic from "../../../Modules/BasicFields"

const chatVariables = [
    {name:'Rest',key:'reset',type:'R'},
    {name:'Vote is active',key:'is_active',type:'R'},
    {name:'# Particepants', key:'count-participants', type:'W'},
    {name:'Target', key:'target',type:'R'},
    {name:'# Winners', key:'count-winners', type:'W'},
    {name:'Winner',key:'winner', type:'W' }
]

const filesList = [
    {name:'Lock asset', key:'lock_asset'},
]

export default function ForeseeingKing( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg 
    const selected = props.selected
    const reset = props.reset

    const [ hashtag, setHashtag ] = useState(null)
    const [ font, setFont ] = useState(null)
    const [ variables, setVariables ] = useState(null)
    const [ files, setFiles ] = useState(null)

    const requiredData = [
        hashtag,
        font,
        variables,
        files
    ]

    const cfgName = "kingmaker_foreseeing_king_cfg"

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setFont( cfg.font || {} )
        setHashtag( cfg.hashtag || "")
        setVariables( cfg.variables || {} )
        setFiles( cfg.files || {} )
    }

    useEffect(() => {
        reload()
    },[])

    useEffect(() => {

        if( requiredData.includes(null) )
        {
            return
        }

        let data = {}
        data.font = font
        data.hashtag = hashtag
        data.variables = variables
        data.files = files
 
        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ font, hashtag, variables, files ])

    if( requiredData.includes(null) )
    {
        return <>FreseeingKing</>
    }

    return (
        <> 
            <SettingsGroup name="Behaviour">
                <Basic.StringInput name="Hashtag" value={hashtag} setValue={setHashtag} />
            </SettingsGroup>
            { font &&
            <FontModule font={font} 
                        setFont={setFont}
                        selected={selected}
                        reset={reset}
            />
            }

            { variables &&
            <VariableModule variables={variables} 
                            setVariables={setVariables} 
                            variableList={chatVariables} 
                            reset={reset}
            />
            }
                
            { files &&
            <FilesModule files={files} 
                         setFiles={setFiles}
                         filesList={filesList}
                         reset={reset}
            />
            }
            
        </>
    )
}
